import * as React from "react";
import { useState, useCallback } from "react";
import type { PropsWithChildren } from "react";

import { MinitourContainer } from "../../../../../Layout/Minitour/MinitourContainer";
import { useUUID } from "../../../../../../../../Common/UUID";
import { KnownErrorTag } from "../../../../../../../../Common/CandyApiClient/Types/ErrorLog/Tags/KnownErrorTag";
import { TagLabel } from "../../../../../../../../Common/CandyApiClient/Types/ErrorLog/Tags/TagLabel";

type Props = PropsWithChildren<{ tag: KnownErrorTag }>;

export const ErrorItemMinitour = ({ tag, children }: Props) => {
    const tourId = `errorsItemMinitour_${tag}`;
    const renderId = useUUID();
    const [visible, setVisible] = useState(false);

    const cb = useCallback(
        (param: HTMLDivElement | null) => {
            if (param !== null) {
                const first = document.querySelector<HTMLElement>(`[data-tour-id="${tourId}"]`);
                const isCurrentFirst = first && first.dataset["renderId"] === renderId;
                if (isCurrentFirst) {
                    setVisible(true);
                }
            }
        },
        [tourId, renderId, setVisible]
    );

    return (
        <div data-tour-id={tourId} data-render-id={renderId} ref={cb}>
            <MinitourContainer
                minitourEnabled={visible}
                openedFrom={"ErrorsItem"}
                id={tourId}
                label={TagLabel[tag]}
                positions={["right middle"]}
                width={"270px"}>
                {children}
            </MinitourContainer>
        </div>
    );
};
